module.exports = __webpack_public_path__ + "static/media/art-clip5.5ca123e4.png";